import React, { useEffect, useState, useRef, forwardRef } from 'react'
import StepButtons from '../components/StepButtons'
import { useStateValue } from '../StateProvider'
import { useInput, TextMaskCustomPhone, TextMaskCustomEmail, TextMaskCustomTaxID } from '../hooks/inputHook'
import { actionTypes } from '../reducer';
import { fieldValidation, fieldValidationPhone, fieldValidationEmail, fieldValidationTaxID } from '../validators/fieldValidation'
import { FormControl, FormHelperText, Grid, IconButton, Input, InputAdornment, InputLabel, MenuItem, TextField, Typography } from '@mui/material';
import { legitEntityArr } from "../helpers/constantVariables";
import { Visibility, VisibilityOff } from '@mui/icons-material';


function BasicInfo({ },ref) {
  const [{ applicantDetails, activeStep, refreshApplicant, goToStep, progressStep }, dispatch] = useStateValue();
  const [showTaxId, setShowTaxId] = useState(false);

  const {
    value: legitEntity,
    setValue: setLegitEntity,
    bind: bindLegitEntity
  } = useInput(applicantDetails?.legit_entity || '');

  const {
    value: companyName,
    setValue: setCompanyName,
    bind: bindCompanyName
  } = useInput(applicantDetails?.business_name || "");

  const {
    value: email,
    setValue: setEmail,
    bind: bindEmail
  } = useInput(applicantDetails?.email || "");

  const {
    value: businessPhone,
    setValue: setBusinessPhone,
    bind: bindBusinessPhone
  } = useInput(applicantDetails?.phone || "");
  
  const {
    value: taxId,
    setValue: setTaxId,
    bind: bindTaxId
  } = useInput(applicantDetails?.ein || "");

  const {
    value: doingBusinessAs,
    setValue: setDoingBusinessAs,
    bind: bindDoingBusinessAs
  } = useInput(applicantDetails?.dba || "");

  const {
    value: mobile,
    setValue: setMobile,
    bind: bindMobile
  } = useInput(applicantDetails?.mobile || "");

  /* const {
    value: website,
    setValue: setWebsite,
    bind: bindWebsite
  } = useInput(applicantDetails?.website || ""); */

  const handleClickShowTaxId = () => {
    setShowTaxId(!showTaxId);
  }

  const handleMouseDownTaxId = (event) => {
    event.preventDefault();
  }

  const onUpdateBasicInfo = () => {
    //console.log("companyName",companyName);
    let validation = validate();
    dispatch({
      type: actionTypes.SET_SUBMIT_APPLICANT_DETAILS,
      applicantDetails: {
        ...applicantDetails,
        legit_entity: legitEntity,
        business_name: companyName,
        email: email,
        phone: businessPhone,
        ein: taxId,
        dba: doingBusinessAs,
        mobile: mobile,
        /* website: website */
      }
    });
    return validation;
  }

  const validate = () => {
    let validateSuccess = { error: false, msg: '' }
    let success = {}
    success = fieldValidation(legitEntity, 'Legit Entity');
    if (success.error) return success;
    success = fieldValidation(companyName, 'Company Name');
    if (success.error) return success;
    success = fieldValidationEmail(email, 'Email');
    if (success.error) return success;
    success = fieldValidation(businessPhone, 'Business Phone');
    if (success.error) return success;
    success = fieldValidation(taxId, 'Tax ID');
    if (success.error) return success;
    success = fieldValidation(mobile, 'Mobile');
    if (success.error) return success;
    return validateSuccess;
  }



  return (
    <>
      <Grid container justifyContent="space-around" minHeight={500} columnSpacing={{ xs: 2, sm: 3, md: 4 }}>
        <Grid textAlign="start" item xs={12}>
          <Typography gutterBottom component="div">
            Now, let's gather some basic Information
          </Typography>
        </Grid>
        <Grid item sm={12} md={12} lg={8} justifyContent="flex-end" textAlign="left" marginTop="20px">
          <TextField
            id="legit-entity"
            label="Legal Entity"
            variant="filled"
            name="legitEntity"
            fullWidth
            select
            required={true}
            error={fieldValidation(legitEntity, "Legal Entity").error}
            helperText={fieldValidation(legitEntity, "Legal Entity").msg}
            {...bindLegitEntity}
          >
            {(legitEntityArr || []).map((legitEntity) => (
              <MenuItem key={legitEntity.code} value={legitEntity.code}>
                {legitEntity.name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            placeholder="Company Name"
            label="Company Name"
            name="companyName"
            required={true}
            {...bindCompanyName}
            error={fieldValidation(companyName, "Company Name").error}
            helperText={fieldValidation(companyName, "Company Name").msg}
            margin="normal"
            fullWidth
            variant="standard"
            autoComplete="off"
          />
          <FormControl required={true} error={fieldValidation(email, "Email").error} variant="standard" margin="normal" fullWidth>
            <InputLabel htmlFor="formatted-text-mask-input">Email Address</InputLabel>
            <Input {...bindEmail} name="email" id="email" autoComplete="off" placeholder="email@email.com" inputComponent={TextMaskCustomEmail} />
            <FormHelperText>{fieldValidation(email, "Email").msg}</FormHelperText>
          </FormControl>
          <FormControl required={true} error={fieldValidation(businessPhone, "Business Phone").error} variant="standard" margin="normal" fullWidth>
            <InputLabel htmlFor="formatted-text-mask-input">Business Phone</InputLabel>
            <Input {...bindBusinessPhone} name="businessPhone" id="businessPhone" inputComponent={TextMaskCustomPhone} autoComplete="off" />
            <FormHelperText>{fieldValidationPhone(businessPhone, "Business Phone").msg}</FormHelperText>
          </FormControl>
          <FormControl required={true} error={fieldValidation(mobile, "Mobile").error} variant="standard" margin="normal" fullWidth>
            <InputLabel htmlFor="formatted-text-mask-input">Mobile</InputLabel>
            <Input {...bindMobile} name="mobile" id="mobile" inputComponent={TextMaskCustomPhone} autoComplete="off" />
            <FormHelperText>{fieldValidationPhone(mobile, "Mobile").msg}</FormHelperText>
          </FormControl>
          <FormControl autoComplete="new-password" required={true} error={fieldValidationTaxID(taxId, "Tax ID").error} variant="standard" margin="normal" fullWidth>
            <InputLabel htmlFor="formatted-text-mask-input">Tax ID</InputLabel>
            <Input
              name="taxId"
              type={showTaxId ? "text" : "password"}
              {...bindTaxId}
              id="taxId"
              autoComplete="new-password"
              inputComponent={TextMaskCustomTaxID}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowTaxId}
                    onMouseDown={handleMouseDownTaxId}
                    edge="end"
                  >
                    {showTaxId ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
            />
            <FormHelperText>{fieldValidationTaxID(taxId, "Tax ID").msg}</FormHelperText>
          </FormControl>
          <TextField
            placeholder="Doing Business As"
            label="Doing Business As"
            name="doingBusinessAs"
            autoComplete="off"
            {...bindDoingBusinessAs}
            margin="normal"
            fullWidth
            variant="standard"
          />
          {/* <TextField
            placeholder="Website"
            label="Website"
            name="website"
            autoComplete="off"
            {...bindWebsite}
            margin="normal"
            fullWidth
            variant="standard"
          /> */}
          <Typography fontSize={"13px"} borderLeft={progressStep > 0 ? "8px solid #0ea723" : "8px solid #e2341a"} marginTop={2} gutterBottom component="div" sx={{paddingTop:"10px", paddingBottom:"10px", paddingLeft:"10px", whiteSpace:"normal", overflowWrap:"break-word", color:"#616365", lineHeight:"16px"}}>
            <span style={{fontWeight:"bold"}}>Important Information About Procedures for Opening a New Account</span><br /><br />
            To help the government fight the funding of terrorism and money laundering activities, Federal law requires all financial institutions to obtain, verify, and record information that identifies each person who opens an account.<br /><br />
            What this means for you: When you open an account, we will ask for your name, address, date of birth, and other information that will allow us to identify you.  We may also ask to see your driver’s license or other identifying documents.
          </Typography>
        </Grid>
        <Grid sx={{ display: { xs: "none", lg: "block" } }} item xs={4}></Grid>
      </Grid>
      <Grid item lg={8}>
        <StepButtons updateInfo={onUpdateBasicInfo} prevBtn={false} ref={ref} />
      </Grid>
    </>
  )
}

export default forwardRef(BasicInfo)